<template>
<div class="fullLoading" v-if="status">
  <div id="nprogress">
    <div class="bar"
         ref="bar"
         role="bar" style="
         display: block;
        "></div>
  </div>
<!--  进度条-->
</div>
</template>

<script>
    export default {
        name: "fullLoading",
      data(){
          return{
            status:false,
            time:1500,
            oldDate:'',
            setLong:-100,
            fn:null
          }
      },
      methods:{
          close(){
            this.status = false
          },
          show({time=1500},fn){
            this.time = time
            this.setLong = -100
            this.status = true
            console.log(time,fn)
            this.fn = fn
            this.$nextTick(_=>{
              // 获取还是有问题
              setTimeout(_=>{
                this.tick()
              })
            })
          },
         tick() {
              let bar = document.querySelector('.bar')

              if (this.setLong < 0) {
                setTimeout(_=>{
                  this.setLong+=10
                  if(bar)bar.style.transform = "translate3d("+this.setLong+"%, 0px, 0px)"
                  this.tick()
                },this.time/10)
              }else{
                this.close()
                console.log(this.fn)
                this.fn&&this.fn()
              }
          }
      },
      mounted(){

      }
    }
</script>

<style lang="less" scoped>
  .fullLoading{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 99999;
    bottom: 0;
    background-color: rgba(0,0,0,.6);
  }

  #nprogress .bar {
    transform: translate3d(-100%, 0px, 0px);
    transition: all 200ms ease 0s;
    background: #67C23A;
  }
  /*#nprogress .peg {*/
  /*  display: block;*/
  /*  position: absolute;*/
  /*  right: 0px;*/
  /*  width: 100px;*/
  /*  height: 100%;*/
  /*  box-shadow: 0 0 10px #29d, 0 0 5px #29d;*/
  /*  opacity: 1.0;*/

  /*  -webkit-transform: rotate(3deg) translate(0px, -4px);*/
  /*  -ms-transform: rotate(3deg) translate(0px, -4px);*/
  /*  transform: rotate(3deg) translate(0px, -4px);*/
  /*}*/

  /*.nprogress-custom-parent {*/
  /*  overflow: hidden;*/
  /*  position: relative;*/
  /*}*/
  /*.nprogress-custom-parent #nprogress .bar {*/
  /*  position: absolute;*/
  /*}*/

  /*@-webkit-keyframes nprogress-spinner {*/
  /*  0%   { -webkit-transform: rotate(0deg); }*/
  /*  100% { -webkit-transform: rotate(360deg); }*/
  /*}*/
  /*@keyframes nprogress-spinner {*/
  /*  0%   { transform: rotate(0deg); }*/
  /*  100% { transform: rotate(360deg); }*/
  /*}*/
</style>
